import {APP_STORE_URL} from '../lib/seo';
export default function AppStoreBadge({className='',href=APP_STORE_URL,appName='Shortcuts Library'}:{className?:string;href?:string;appName?:string}){
 return <a href={href} className={`store-badge ${className}`} aria-label={`Download ${appName} on the App Store`}><img src="/brand/app-store-badge.svg" alt="Download on the App Store" width="156" height="52"/></a>;
}
